"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcForm = void 0;
var react_1 = __importDefault(require("react"));
var AcFormField_1 = require("./AcFormField");
var AcForm = function (_a) {
    var config = _a.config, fieldMap = _a.fieldMap, mode = _a.mode, onChange = _a.onChange, onBlur = _a.onBlur, showErrors = _a.showErrors;
    var renderFields = function () {
        return Object.keys(config)
            .filter(function (key) {
            if (mode === 'edit') {
                var fieldConfig = config[key];
                return !fieldConfig.readOnly;
            }
            return true;
        })
            .map(function (key) {
            var field = fieldMap[key];
            if (field.component) {
                var Component = field.component;
                return (react_1.default.createElement(Component, __assign({ key: field.fieldName ? field.fieldName : key, fieldName: field.fieldName ? field.fieldName : key, type: field.type, label: field.label, tooltip: field.tooltip, errorId: showErrors ? field.errorId : '', invalid: field.invalid, required: field.required, value: field.value, readOnly: mode === 'view' || field.readOnly, plaintext: mode === 'view' || field.plaintext, onChange: onChange, onBlur: onBlur, options: field.options, customHTML: field.customHTML, hide: field.hide, disabled: field.disabled, rows: field.rows, placeholder: field.placeholder }, field === null || field === void 0 ? void 0 : field.componentProps), field.description));
            }
            return (react_1.default.createElement(AcFormField_1.AcFormField, { key: field.fieldName ? field.fieldName : key, fieldName: field.fieldName ? field.fieldName : key, type: field.type, label: field.label, tooltip: field.tooltip, errorId: showErrors ? field.errorId : '', invalid: field.invalid, required: field.required, value: field.value, readOnly: mode === 'view' || field.readOnly, plaintext: mode === 'view' || field.plaintext, onChange: onChange, onBlur: onBlur, options: field.options, customHTML: field.customHTML, hide: field.hide, disabled: field.disabled, rows: field.rows, placeholder: field.placeholder }, field.description));
        });
    };
    return react_1.default.createElement("div", null, renderFields());
};
exports.AcForm = AcForm;
exports.AcForm.displayName = 'AcForm';
//# sourceMappingURL=AcForm.js.map